<template>
  <div id="pano">
    <krpano
      ref="thepano"
      :xml="'static/krpano/videos/' + exhibitid + '.xml?' + rightnow()"
      :consolelog="true"
      :debug="true"
      :vars="{debugmode: true, showerrors: true}"
      :basepath="'static/krpano/common/krpano/'"
      :passQueryParameters="true"
      :initvars="{router: this.$router, exhibitid: exhibitslug, iosmodel: this.ios_model}"
      @panoCreated="init">
    </krpano>
    <back-button></back-button>
    <router-link class="button allmedia" to="allmedia">View All Media</router-link>
  </div>
</template>

<script>
import iosfudge from '../iosfudge.js'
export default {
  name: 'pano',
  props: {
    exhibitslug: {
      type: String
    }
  },
  computed: {
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    }
  },
  data () {
    return {
      ios_model: iosfudge()
    }
  },
  methods: {
    init (k) {
      // Call an action defined in the krpano XML
      k.call('init')
    },
    rightnow () {
      return Date.now()
    },
    destroyit (e) {
      this.$refs.thepano.removePano()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.destroyit()
    next()
  }
}
</script>
<style lang="scss" scoped>
#pano {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}
.vue-krpano {
  width: 100%;
  height: 100%;
}
a {
  position:absolute;
  top: 10px;
  right: 10px;
  background: black;
  color: white;
  display: inline-block;
}
button {
  position:absolute;
  left: 10px;
  top: 10px;
  display: inline-block;
}
</style>
